import { ref } from 'vue'

type AlertType = 'success' | 'error' | 'info' | 'warning' | undefined

export function useAlert() {
  const alertMessage = ref('')
  const alertType = ref<AlertType>(undefined)
  const isShowSnackBar = ref(false)

  function showAlert(message: string, type: AlertType = 'info') {
    alertMessage.value = message
    alertType.value = type
    isShowSnackBar.value = true
    setTimeout(() => (isShowSnackBar.value = false), 3000)
  }

  function clearAlert() {
    alertMessage.value = ''
  }

  return {
    alertMessage,
    alertType,
    isShowSnackBar,
    showAlert,
    clearAlert,
  }
}
